// Utilitários de formatação para o módulo de postes de iluminação

export const formatarData = (data) => {
  if (!data) return '-';
  return new Date(data).toLocaleDateString('pt-BR');
};

export const formatarDataHora = (data) => {
  if (!data) return '-';
  return new Date(data).toLocaleString('pt-BR');
};

export const formatarStatus = (status) => {
  const statusMap = {
    'Funcionando': 'Funcionando',
    'Alerta': 'Em Alerta',
    'Defeito': 'Com Defeito'
  };
  return statusMap[status] || status;
};

export const obterCorStatus = (status) => {
  const cores = {
    'Funcionando': '#4caf50',
    'Alerta': '#ff9800',
    'Defeito': '#f44336'
  };
  return cores[status] || '#757575';
};

export const obterIconeStatus = (status) => {
  const icones = {
    'Funcionando': '🟢',
    'Alerta': '🟡',
    'Defeito': '🔴'
  };
  return icones[status] || '⚪';
};

export const formatarNumeroIdentificacao = (numero) => {
  if (!numero) return '';
  // Remove caracteres não numéricos e formata
  const apenasNumeros = numero.replace(/\D/g, '');
  if (apenasNumeros.length <= 4) {
    return apenasNumeros;
  }
  // Formato: XXXX (4 dígitos)
  return apenasNumeros.slice(0, 4);
};

export const validarNumeroIdentificacao = (numero) => {
  if (!numero || numero.trim() === '') {
    return 'Número de identificação é obrigatório';
  }
  if (numero.length < 1) {
    return 'Número de identificação deve ter pelo menos 1 caractere';
  }
  return null;
};

export const validarCoordenadas = (latitude, longitude) => {
  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);
  
  if (isNaN(lat) || isNaN(lng)) {
    return 'Coordenadas devem ser números válidos';
  }
  
  if (lat < -90 || lat > 90) {
    return 'Latitude deve estar entre -90 e 90';
  }
  
  if (lng < -180 || lng > 180) {
    return 'Longitude deve estar entre -180 e 180';
  }
  
  return null;
};

export const formatarCoordenada = (coordenada, casasDecimais = 6) => {
  if (!coordenada) return '';
  const num = parseFloat(coordenada);
  if (isNaN(num)) return '';
  return num.toFixed(casasDecimais);
};